<app-card class="page-container">
  <app-card-header>
    <app-card-title>
      <div class="flex gap-md mr-auto">
        <app-icon name="check-circle" />
        <span>{{ 'submission.success.title' | translate }}</span>
      </div>
    </app-card-title>
  </app-card-header>

  <app-card-content>
    @if (loading()) {
    <div class="flex flex-column flex-align-center p-xl gap-lg">
      <app-spinner />
    </div>
    } @else if (error()) {
    <div class="flex flex-column flex-align-center p-xl gap-lg">
      <p class="error-message">{{ error() }}</p>
    </div>
    } @else {
    <div class="flex flex-column flex-align-center text-center p-xl gap-lg" data-testid="success-message">
      <div class="success-icon">
        <app-icon name="check-circle" [size]="64" />
      </div>
      <h3>{{ 'scan.success.title' | translate }}</h3>
      <p class="success-message">{{ 'scan.success.message' | translate:{
        formName: form()?.name ?? '',
        checkpointName: checkPoint()?.name ?? ''
        } }}</p>

      <div class="flex flex-column gap-xl mt-lg success-actions">
        <app-button variant="filled" size="lg" (click)="fillAgain()" data-testid="fill-again-button">
          <app-icon name="clipboard-pen" />
          {{ 'scan.success.fillAgain' | translate:{ formName: form()?.name ?? '' } }}
        </app-button>

        <app-button variant="outlined" size="lg" (click)="scanAnother()" data-testid="scan-another-button">
          <app-icon name="camera" />
          {{ 'scan.success.scanAnother' | translate }}
        </app-button>

        <app-button variant="outlined" size="lg" (click)="viewHistory()" data-testid="view-history-button">
          <app-icon name="list" />
          {{ 'scan.success.viewHistory' | translate:{ formName: form()?.name ?? '' } }}
        </app-button>
      </div>
    </div>
    }
  </app-card-content>
</app-card>